import React, {useState} from "react";
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarFilterButton,
} from '@mui/x-data-grid';
import {Typography} from '@material-ui/core';
import {useSelector} from "react-redux";
import {map_other_events} from "./utils/mapping";
import {formattingMoney} from "./utils/formatting";
import {getCurrencySymbol} from "./utils/currency";

export default function () {
    const data = useSelector(store => store.portfolio?.data);
    const rows = map_other_events(data);
    const [sortModel, setSortModel] = useState([
        {
            field: 'd',
            sort: 'desc',
        },
    ]);
    const columns = [
        {
            field: 'ticker',
            headerName: 'Актив',
            description: 'Актив',
            flex: 1,
            minWidth: 150,
            renderCell: (params) => (
                <div>
                    <Typography variant="body2">{params.value}</Typography>
                    <Typography color="textSecondary" variant="body2">{params.api.getCellValue(params.id, 'name')}</Typography>
                </div>
            )
        },
        {
            field: 'type_event',
            headerName: 'Событие',
            description: 'Тип события',
            flex: 1,
            minWidth: 120
        },
        {
            field: 'd',
            type: 'date',
            align: 'right',
            headerName: 'Дата',
            description: 'Дата',
            valueFormatter: (params) => {
                return `${(new Date(params.value)).toLocaleDateString('ru-RU',{year: 'numeric', month: 'short', day: 'numeric'})}`;
            },
            width: 125,
        },
        {
            field: 'v',
            headerName: 'Значение',
            description: 'Значение',
            type: 'number',
            align: 'right',
            minWidth: 70,
            valueFormatter: (params) => {
                return `${formattingMoney(Number(params.value))}`;
            },
        },
        {
            field: 'cnt',
            headerName: 'Кол-во',
            description: 'Количество бумаг в портфеле',
            type: 'number',
            align: 'right',
            hide: true,
            minWidth: 90,
            valueFormatter: (params) => {
                return `${formattingMoney(Number(params.value))}`;
            },
        },
    ];

    return (
                <DataGrid
                    autoHeight
                    pageSize={25}
                    columns={columns}
                    rows={rows}
                    sortModel={sortModel}
                    onSortModelChange={(model) => setSortModel(model)}
                    disableColumnMenu
                    components={{
                        Toolbar: function CustomToolbar() {
                            return (
                                <GridToolbarContainer>
                                    <GridToolbarColumnsButton />
                                    <GridToolbarFilterButton />
                                </GridToolbarContainer>
                            );
                        },
                    }}
                />
    );
}
